import { observable, computed, makeObservable } from 'mobx'
import { LatLng } from 'leaflet'
import _ from 'lodash'

// Represent a lat/long position on the map
class Position {
  @observable _latitude = null
  @observable _longitude = null

  constructor () {
    makeObservable(this)
  }

  @computed get latitude () { return this._latitude }
  set latitude (value) {
    if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
      this._latitude = null
    } else {
      this._latitude = _.clamp(Number(value), -90, 90)
    }
  }

  @computed get longitude () { return this._longitude }
  set longitude (value) {
    if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
      this._longitude = null
    } else {
      this._longitude = _.clamp(Number(value), -180, 180)
    }
  }

  // Get this position as a Leaflet LatLng
  @computed get latLng () {
    return (this.latitude !== null && !isNaN(this.latitude) && this.longitude !== null && !isNaN(this.longitude))
      ? new LatLng(this.latitude, this.longitude)
      : null
  }

  // Get this position as a [longitude, latitude] format
  // which GeoJSON uses for coordinates
  @computed get geoJSON () {
    return (this.latitude !== null && !isNaN(this.latitude) && this.longitude !== null && !isNaN(this.longitude))
      ? [this.longitude, this.latitude]
      : null
  }

  set latLng (value) {
    this.latitude = _.get(value, 'lat', null)
    this.longitude = _.get(value, 'lng', null)
  }
}

export default Position
